<template>
  <div class="refund-type">
    <div class="refund-top" v-for="(item,key) in goodsList" :key="key">
		<div class="refund-top-l"><img :src="item.cart_info.productInfo.image"></div>
		<div class="refund-top-r">
			<p>{{ item.cart_info.productInfo.store_name }}</p>
			<p v-if="item.cart_info.productInfo.attrInfo">{{ item.cart_info.productInfo.attrInfo.suk }}</p>
			<p v-if="item.cart_info.spec_values">{{ item.cart_info.spec_values }}</p>
		</div>
	</div>
	<ul>
		<li>选择售后方式</li>
		<li @click="$router.push('/order/only_refund/' + $route.params.id)">
			<div>
				<p>仅退款</p>
				<p class="info">未收到货，或无需退货仅需退款</p>
			</div>
			<i class="iconfont icon-jiantou"></i>
		</li>
		<li @click="$router.push('/order/refund_goods/' + $route.params.id)">
			<div>
				<p>退货退款</p>
				<p class="info">已收到货，需要退货退款</p>
			</div>
			<i class="iconfont icon-jiantou"></i>
		</li>
		<li v-if="goodsList.length == 1" @click="$router.push('/order/exchange_goods/' + $route.params.id)">
			<div>
				<p>换货</p>
				<p class="info">已收到货，需要更换收到的商品</p>
			</div>
			<i class="iconfont icon-jiantou"></i>
		</li>
	</ul>
  </div>
</template>

<script>
import { getRefundGoods, RefundVerify } from "@api/order";
export default {
  name: "RefundType",
  data: function() {
    return {
	  goodsList: [],
    };
  },
  watch: {
    $route(n) {
	  if(n.name == 'RefundType'){
		this.getRefundVerify();
		this.getRefundGoods();
	  }
    }
  },
  mounted: function() {
    this.getRefundGoods();
    this.getRefundVerify();
  },
  methods: {
	getRefundGoods(){
		let that = this;
		let unique = that.$route.params.id;
		getRefundGoods(unique).then(res => {
			that.goodsList = res.data.cartInfo;
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	getRefundVerify(){
		let that = this;
		let unique = that.$route.params.id;
		RefundVerify(unique).then(res => {
			
		}).catch(err => {
			that.$dialog.error(err.msg);
			setTimeout(function(){
				that.$router.replace('/order/list/');
			},1000)
		});
	}
  }
};
</script>
<style scoped>
.refund-top{padding: 0.2rem 0 0.2rem 0.4rem;background-color: #fff;overflow: hidden;}
.refund-top-l{width: 32%;border-radius: 7px;float: left;}
.refund-top-l img{display: block;width: 100%;}
.refund-top-r{float: left;margin-left: 0.2rem;width: 60%;overflow: hidden;margin-top: 0.2rem;}
.refund-type ul{background-color: #fff;padding-left: 0.4rem;margin-top: 0.3rem;}
.refund-type ul li{padding: 0.35rem 0.5rem 0.35rem 0.1rem;border-bottom: 1px solid #eee;display: flex;align-items: center;}
.refund-type ul li:last-child{border-bottom: none;}
.refund-type ul li>div{width: 95%;}
.refund-type ul li>div .info{font-size: 0.26rem;color: #999;margin-top: 0.1rem;}
.refund-type ul li i{color: #999;font-size: 0.35rem;width: 5%;}
@media screen and (min-width:960px){
	.refund-type{width: 3.75rem;}
	.refund-top{padding: 0.1rem 0 0.1rem 0.2rem;}
	.refund-top-r{margin-left: 0.1rem;margin-top: 0.1rem;}
	.refund-type ul{padding-left: 0.2rem;margin-top: 0.15rem;}
	.refund-type ul li{padding: 0.17rem 0.25rem 0.17rem 0.05rem;}
	.refund-type ul li>div .info{font-size: 0.13rem;margin-top: 0.05rem;}
	.refund-type ul li i{font-size: 0.17rem;}
}
</style>